import { Component, OnInit, AfterViewChecked, Input, Output, EventEmitter, ElementRef, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePickerModel, DatePickerService } from './shared';
import { KEY_CONFIG } from './../../config/key-config';
import { UtilityService } from './../../providers';

const monthLabels: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'];


@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePickerService],
})
export class DatePickerComponent implements  AfterViewChecked, OnChanges{

  @Input() datePickerInput: DatePickerModel;
  @Input() datePickerHeading: string;
  @Input() showError: boolean;
  @Output() updateDate = new EventEmitter<any>();

  private _selectedMonth: number;
  private _selectedYear: number;
  private _currentDate: Date;
  private _showPlaceHolder: boolean;
  private _selectedRowIndex: number;
  private _selectedDateIndex: number;
  public weekLabels;
  public rows: Array<any>;
  public monthLabel: string;
  public dateLabel: string;
  public disableDown: boolean;
  public disableUp: boolean;
  public showCalendar: boolean;
  public navigateToNext: string;
  public navigateKeyIndex = -1;
  public openCalendar: any;

  private bindEvent: EventListener = this.closeHandler.bind(this);
  private bindkeyEvent: EventListener = this.handleKeydown.bind(this);

  constructor(private el: ElementRef,
    private utilService: DatePickerService,
    private utilityService: UtilityService) {
    this.weekLabels = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    this.showCalendar = false;
    this.navigateToNext = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    this._currentDate = new Date();
    if (!this.datePickerInput.selectedDate) {
      this.datePickerInput.selectedDate = new Date();
      this._showPlaceHolder = true;
    }
    this._selectedMonth = this.datePickerInput.selectedDate.getMonth();
    this._selectedYear = this.datePickerInput.selectedDate.getFullYear();
    this.dateLabel = this._showPlaceHolder ? '00/00/0000' : this.utilService.formatDate('mm/dd/yyyy', this.datePickerInput.selectedDate);
    this.refreshView(0);
    this.monthLabel = monthLabels[this._selectedMonth] + ' ' + this._selectedYear;
    window.document.addEventListener('click', this.bindEvent);
    window.document.addEventListener('keydown', this.bindkeyEvent);
    this.openCalendar = this.el.nativeElement.getElementsByClassName('date-input-text');
  }

  selectDate(dateObj: any, rowIndex, col) {
    this.rows[this._selectedRowIndex][this._selectedDateIndex].selected = false;
    this._selectedRowIndex = rowIndex;
    this._selectedDateIndex = col;
    this.datePickerInput.selectedDate = dateObj.date;
    this.rows[rowIndex][col].selected = true;
    this.showCalendar = false;
    this._showPlaceHolder = false;
    this.dateLabel = this.utilService.formatDate('mm/dd/yyyy', new Date(this.datePickerInput.selectedDate.getTime()))
    this.updateDate.emit({ 'date': this.datePickerInput.selectedDate, 'id': this.datePickerInput.id });
  }

  toggle($event) {
    if (!this.datePickerInput.disable) {
      this.showCalendar = !this.showCalendar;
      if(this.showCalendar){
        this.openCalendar[0].style.border = "1px solid #0568ae";
      }
      else {
        this.openCalendar[0].style.border = "1px solid #d2d2d2";
      }
      // this.el.nativeElement.getElementsByClassName('icon_calendar')[0].style.display = "none";
    }
    const date = this._showPlaceHolder ? this._currentDate : this.datePickerInput.selectedDate;
    this._selectedMonth = date.getMonth();
    this._selectedYear = date.getFullYear();
    this.refreshView(0);
    this.navigateToNext = '';
  };

  keyUp($event) {
    if ($event.key === 'Enter') {
      this.showCalendar = true;
    }
  }

  closeHandler(event) {
    if (this.el.nativeElement.contains(event.target)) {
      return;
    } else {
      this.showCalendar = false;
      this.openCalendar[0].style.border = "1px solid #d2d2d2";
    }
  }

  private refreshView(direction: number) {
    [this._selectedMonth, this._selectedYear] = this.utilService.getSelectedMonth(direction, this._selectedMonth, this._selectedYear);

    this.monthLabel = monthLabels[this._selectedMonth] + ' ' + this._selectedYear;
    const calendarStart = this.utilService.getStartDate(this._selectedMonth, this._selectedYear);
    let calendarDates: Date[],
      selectedRowIndex,
      selectedDateIndex;
    ({ 'datesArray': calendarDates, 'selectedRowIndex': selectedRowIndex, 'selectedDateIndex': selectedDateIndex }
      = this.utilService.getCalendarDates(calendarStart, 42, this.datePickerInput.selectedDate));
    [this.disableDown, this.disableUp] = this.utilService.checkNavigation(calendarDates,
      this.datePickerInput.minDate, this.datePickerInput.maxDate);
    const calendarDatesObject: Array<any> = this.utilService.createDateObject(calendarDates,
      this._selectedMonth, this.datePickerInput.minDate, this.datePickerInput.maxDate);
    this.rows = this.utilService.formCalendarView(calendarDatesObject, this._selectedMonth);
    if (this.rows[selectedRowIndex]) {
      this._selectedRowIndex = selectedRowIndex;
      this._selectedDateIndex = selectedDateIndex;
      if (!this._showPlaceHolder) {
        this.rows[selectedRowIndex][selectedDateIndex].selected = true;
      }
    }
  }

  ngAfterViewChecked() {
    if (this.showCalendar) {
      const focusabbleElements = this.utilService.getFocusableElements(this.el.nativeElement, 'div.calendar');

      const navigateDayElements = this.utilService.getFocusableElements(this.el.nativeElement, 'div.calendar tbody');

      if (focusabbleElements.indexOf(document.activeElement) === -1) {
        if (this.navigateToNext === 'left') {
          if (this.navigateKeyIndex === -1) {
            navigateDayElements[navigateDayElements.length - 1].focus();
          } else {
            let keyIndDiff = navigateDayElements[navigateDayElements.length - 1].parentElement.cellIndex - this.navigateKeyIndex;
            keyIndDiff = keyIndDiff < 0 ? keyIndDiff + 7 : keyIndDiff;
            if (typeof navigateDayElements[navigateDayElements.length - 1 - keyIndDiff] !== 'undefined') {
              navigateDayElements[navigateDayElements.length - 1 - keyIndDiff].focus();
            } else {
              navigateDayElements[navigateDayElements.length - 1].focus();
            }
          }
        } else if (this.navigateToNext === 'right') {
          if (this.navigateKeyIndex === -1) {
            navigateDayElements[0].focus();
          } else {
            let keyIndDiff = this.navigateKeyIndex - navigateDayElements[0].parentElement.cellIndex;
            keyIndDiff = keyIndDiff < 0 ? keyIndDiff + 7 : keyIndDiff;
            if (typeof navigateDayElements[keyIndDiff] !== 'undefined') {
              navigateDayElements[keyIndDiff].focus();
            } else {
              navigateDayElements[0].focus();
            }
          }
        } else {
          focusabbleElements[0].focus();
        }
      }
    }
  }

  setViewData(moveTo, ind) {
    this.refreshView(moveTo === 'left' ? -1 : 1);
    this.navigateToNext = moveTo;
    this.navigateKeyIndex = ind;
  }

  handleKeydown(event) {
    if (!this.showCalendar) {
      return;
    } else if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.showCalendar = false;
      return;
    }
    const focusabbleElements = this.utilService.getFocusableElements(this.el.nativeElement, 'div.calendar');

    const navigateDayElements = this.utilService.getFocusableElements(this.el.nativeElement, 'div.calendar tbody');

    if (event.keyCode === KEY_CONFIG.tabKey) {
      if (focusabbleElements.indexOf(event.target) === 0 && event.shiftKey) {
        event.preventDefault();
        focusabbleElements[focusabbleElements.length - 1].focus();
      } else if ((focusabbleElements.indexOf(event.target) === focusabbleElements.length - 1 && !event.shiftKey) ||
        focusabbleElements.indexOf(event.target) === -1) {
        event.preventDefault();
        focusabbleElements[0].focus();
      }
    } else if ([KEY_CONFIG.arrowLeft, KEY_CONFIG.arrowUp, KEY_CONFIG.arrowRight, KEY_CONFIG.arrowDown,
    KEY_CONFIG.home, KEY_CONFIG.end].indexOf(event.keyCode) !== -1) {
      event.preventDefault();
      if (navigateDayElements.indexOf(event.target) === -1) {
        navigateDayElements[0].focus();
      } else if (event.keyCode === KEY_CONFIG.arrowLeft) {
        const indexOfCE = navigateDayElements.indexOf(event.target);

        if (indexOfCE === 0) {
          if (!this.disableDown) {
            this.setViewData('left', -1);
          }
        } else {
          navigateDayElements[indexOfCE - 1].focus();
        }
      } else if (event.keyCode === KEY_CONFIG.arrowRight) {
        const indexOfCE = navigateDayElements.indexOf(event.target);

        if (indexOfCE === navigateDayElements.length - 1) {
          if (!this.disableUp) {
            this.setViewData('right', -1);
          }
        } else {
          navigateDayElements[indexOfCE + 1].focus();
        }
      } else if (event.keyCode === KEY_CONFIG.arrowUp) {
        const indexOfCE = navigateDayElements.indexOf(event.target);

        if (indexOfCE < 7) {
          if (!this.disableDown) {
            this.setViewData('left', event.target.parentElement.cellIndex);
          }
        } else {
          navigateDayElements[indexOfCE - 7].focus();
        }
      } else if (event.keyCode === KEY_CONFIG.arrowDown) {
        const indexOfCE = navigateDayElements.indexOf(event.target);

        if (indexOfCE + 7 > navigateDayElements.length - 1) {
          if (!this.disableUp) {
            this.setViewData('right', event.target.parentElement.cellIndex);
          }
        } else {
          navigateDayElements[indexOfCE + 7].focus();
        }
      } else if (event.keyCode === KEY_CONFIG.home) {
        navigateDayElements[0].focus();
      } else if (event.keyCode === KEY_CONFIG.end) {
        navigateDayElements[navigateDayElements.length - 1].focus();
      }
    }
  }
}
